export const ConfigurationColor = {
    ConfigurationObject: "ConfigurationObject",
    ConfigurationGroup: "ConfigurationGroup",
    ConfigurationAttribute: "ConfigurationAttribute",
    ConfigurationValue: "ConfigurationValue",
    ConfigurationInformation: "ConfigurationInformation",
    ValueTemplate: "ValueTemplate",
    NestedValueTemplate: "NestedValueTemplate",
    Navigation: "Navigation",
    Miscellaneous: "Miscellaneous",
    Control: "Control",
    Layout: "Layout",
    LayoutRow: "LayoutRow",
    LayoutCell: "LayoutCell",
};
//# sourceMappingURL=ConfigurationColor.js.map